<template>
  <!-- 左一 基本信息 -->
  <div class="basic-info">
    <el-table :data="tableData" ref="table">
      <el-table-column
        v-for="(item, index) in columnData"
        :key="index"
        :min-width="item.width"
        :label="item.label"
      >
        <template #default="scope">
          <div
            :class="
              setTimeClass(
                scope.row,
                scope.row[item.value],
                item.label,
                'normal'
              )
            "
          >
            <span>{{ scope.row[item.value] }}</span>
          </div>
          <div
            :class="
              setTimeClass(
                scope.row,
                scope.row[item.value],
                item.label,
                'tooltip'
              )
            "
          >
            <el-tooltip :content="checkDelayTxt(scope.row, item.label)" placement="top">
              <span>{{ scope.row[item.value] }}</span>
            </el-tooltip>
          </div>
          <!-- <el-tooltip v-if="isDelay&&item.label=='午报'&&(scope.row.info=='更新时间'||scope.row.info=='ETA')"
                        :content="checkDelayTxt(scope.row)"
                        placement="top">
              <span>{{scope.row[item.value]}}</span>
            </el-tooltip> -->
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import moment from "moment";
import { toRaw } from "@vue/reactivity";
export default {
  props: {
    currentAisShipData: {
      type: Object,
      default: () => {
        return null;
      },
    },
    currentNoonData: {
      type: Object,
      default: () => {
        return null;
      },
    },
  },
  data() {
    return {
      listData: [
        { label: "更新时间", value: "updateTime" },
        { label: "航速", value: "speed" },
        { label: "目的港", value: "destinationPort" },
        { label: "ETA", value: "ETATime" },
        { label: "经纬度", value: "Lonlat" },
        { label: "状态", value: "state" },
        { label: "航艏向", value: "heading" },
        { label: "船迹向", value: "cog" },
      ],
      tableData: [
        { info: "", autoAIS: "", noon: "" },
        { info: "", autoAIS: "", noon: "" },
        { info: "", autoAIS: "", noon: "" },
        { info: "", autoAIS: "", noon: "" },
        { info: "", autoAIS: "", noon: "" },
        { info: "", autoAIS: "", noon: "" },
        { info: "", autoAIS: "", noon: "" },
        { info: "", autoAIS: "", noon: "" },
      ],
      columnData: [
        { value: "info", label: "", width: "16" },
        { value: "autoAIS", label: "自动AIS", width: "37" },
        { value: "noon", label: "午报", width: "37" },
      ],
      shipList: [], //所有船只信息
      shipName: "", //船名
      delayTxt: {
        time: "",
        ETAtime: "",
        AISTime: ""
      }, //延迟提示
      isETADelay: false, //午报ETA延迟警告
      ETAdelayTxt: "", //ETA延迟提示
    };
  },
  watch: {
    currentNoonData(newV) {
      this.handleNoonData(newV);
    },
    currentAisShipData(newV) {
      this.handleAisData(newV);
    },
  },
  computed: {},
  mounted() {},
  methods: {
    //校验午报更新时间
    setTimeClass(row, value, label, type) {
      this.isDelay = false;
      if (label == "午报" && row.info == "更新时间") {
        let className = this.checkTime(value, "time");
        if (type == "tooltip" && this.delayTxt.time != "") {
          return className;
        } else if (type == "normal" && this.delayTxt.time == "") {
          return "";
        } else {
          return "hide";
        }
      } else if (label == "午报" && row.info == "ETA") {
        let className = this.checkTime(value, "ETAtime", row.preETATime);
        if (type == "tooltip" && this.delayTxt.ETAtime != "") {
          return className;
        } else if (type == "normal" && this.delayTxt.ETAtime == "") {
          return "";
        } else {
          return "hide";
        }
      } else if (label === "自动AIS" && row.info === "更新时间") {
        let className = this.checkTime(value, "AIS");
        if (type == "tooltip" && this.delayTxt.AISTime != "") {
          return className;
        } else if (type == "normal" && this.delayTxt.AISTime == "") {
          return "";
        } else {
          return "hide";
        }
      } else {
        if (type == "tooltip") {
          return "hide";
        } else {
          return "";
        }
      }
    },
    // 判断时间
    checkTime(listTime, type, preETATime = '--') {
      if (listTime == "--") {
        return "";
      }
      let now = moment(); //当前时间
      let afterTomorrow = moment(listTime).add(2, "days"); //48小时
      let tomorrow = moment(listTime).add(1, "days"); //24小时
      // 24小时 < 午报时间 < 48小时
      if ( type === "time" && now > tomorrow && now < afterTomorrow) {
        this.delayTxt.time = "超过24小时未更新午报";
        return "yellow";
      }
      // 午报时间 > 48小时
      else if (type === "time" && now > afterTomorrow ) {
        this.delayTxt.time = "超过48小时未更新午报";
        return "red";
      } // 午报到港时间 3-6小时
      else if (type === "ETAtime" && preETATime !== '--' && this.judgeTimeRange(listTime, preETATime, 6, 3)) {
        this.delayTxt.ETAtime = "ETA与上次午报相比超过3小时";
        return "yellow";
        // 午报到港时间 6小时及以上
      } else if (type === "ETAtime" && preETATime !== '--' && this.judgeTimeRange(listTime, preETATime, 6)) {
        this.delayTxt.ETAtime = "ETA与上次午报相比超过6小时";
        return "red";
        
      }
      // AIS更新时间 12小时 > 6小时
      else if (type === "AIS" && this.judgeTimes(listTime, 'h', 12, 6)) {
        this.delayTxt.AISTime = "超过6小时未更新AIS";
        return "red";
      }
      // AIS更新时间 > 12小时
      else if (type === "AIS" && this.judgeTimes(listTime, 'h', 12)) {
        this.delayTxt.AISTime = "超过12小时未更新AIS";
        return "red";
      } else {
        if (type == "time") {
          this.delayTxt.time = "";
        }
        if (type == "ETAtime") {
          this.delayTxt.ETAtime = "";
        }
        return "";
      }
    },
    // 判断午报到港时间范围
    judgeTimeRange(time, preTime, max, min = false) {
      // 判断时间相差3-6小时 
      if (min) {
        // (preTime + 3) < time < (preTime + 6) || (preTime - 3) < time < (preTime - 6)
        return moment(preTime).isBetween(moment(time).add(min, 'h'), moment(time).add(max, 'h')) || moment(preTime).isBetween(moment(time).subtract(min, 'h'), moment(time).subtract(max, 'h'))
      }
      // 判断时间相差6小时及以上
      else {
        // (preTime - 6) <= time <= (preTime + 6)
        return moment(preTime).isAfter(moment(time).add(max, 'h')) || moment(preTime).isBefore(moment(time).subtract(max, 'h')) || moment(preTime).isSame(moment(time).add(max, 'h')) || moment(preTime).isSame(moment(time).subtract(max, 'h'))
      }
    },
    // 判断AIS更新时间和午报时间
    judgeTimes(time, type, max, min = false) {
      // 最大时间边界
      const maxTime = moment(time).add(max, type)
      if (min) {
        // 判断在时间范围内或者等于最大时间范围
        return moment().isBetween(moment(time).add(min, type), maxTime) || moment().isSame(maxTime)
      } else {
        // 判断是否超过最大范围
        return moment().isAfter(maxTime)
      }

    },
    // 判断tooltip显示的数据
    checkDelayTxt(row,label) {
      if (row.info == "更新时间" && label === '午报') {
        return this.delayTxt.time;
      } else if (row.info == "更新时间" && label === '自动AIS') {
        return this.delayTxt.AISTime;
      } else if (row.info == "ETA") {
        return this.delayTxt.ETAtime;
      }
    },
    // 处理 午报 数据
    handleNoonData(value) {
      if (value) {
        const data = toRaw(value);
        let tabledata = this.tableData;
        let list = [];
        list.destinationPort = data.destination ? data.destination : "--"; //目的港
        list.updateTime = data.report_date ? data.report_date : "--"; //更新时间
        list.speed = data.speed
          ? parseFloat(data.speed).toFixed(2) + "节"
          : "--"; //航速
        list.ETATime = data.ETA ? data.ETA : "--"; //ETA
        list.preETATime = data.PRE_ETA ? data.PRE_ETA : "--"; //上一次ETA时间
        list.Lonlat = data.position ? data.position : "--";
        // const array = list.Lonlat.split(" ");
        // list.lat = array[0];
        // list.lon = array[array.length - 1];
        list.cog = data.ship_track_direction ? data.ship_track_direction : "--";
        list.heading = data.ship_heading ? data.ship_heading : "--";
        list.state = data.status ? this.NoonDataStatusMap(data.status.toLowerCase()) : "--";
        this.listData.forEach((item, index) => {
          for (let i in list) {
            if (i == item.value) {
              tabledata[index].noon = list[i];
            }
            if (i === 'ETATime' && item.value === 'ETATime') {
              tabledata[index].preETATime = list.preETATime
            }
          }
        });
        this.tableData = tabledata;
      }
    },

    NoonDataStatusMap(status) {
      let statusMap = ''
      switch(status) {
        case 'underway':
          statusMap = "在航";
          break;
        case 'berthing':
          statusMap = "靠泊";
          break;
        case 'berthed':
          statusMap = "靠泊";
          break;
        case 'anchoring':
          statusMap = "锚泊";
          break;
        case 'anchored':
          statusMap = "锚泊";
          break;
        case 'drifting':
          statusMap = "漂航";
          break;
        default:
          statusMap = status;
          break;
      }
      return statusMap
    },

    // 获取数据（包括Ais表格数据
    handleAisData(value) {
      if (value) {
        const item = toRaw(value);
        let tabledata = this.tableData;
        this.shipName = item.name ? item.name : "--"; //船名
        // console.log(this.shipName);
        let list = [];
        const dest_port_name = item.destination ? item.destination.cName || item.destination.eName : "--" //目的港
        list.destinationPort = item.aisDst ? item.aisDst : dest_port_name
        list.updateTime = item.lastTime
          ? moment(item.lastTime * 1000).format("YYYY-MM-DD HH:mm:ss")
          : "--"; //更新时间
        const eta_time = item.eta ? moment(item.eta).utc().format('YYYY-MM-DD HH:mm:ss') : "--" //ETA
        list.speed = item.sog ? parseFloat(item.sog).toFixed(2) + "节" : "--" //航速
        list.ETATime = item.aisEta ? item.aisEta : eta_time
        list.lon = this.ToDegrees(item.lon, "lon")?this.ToDegrees(item.lon, "lon"):"--"
        list.lat = this.ToDegrees(item.lat, "lat")?this.ToDegrees(item.lat, "lat"):"--"
        list.Lonlat =
           list.lat +
          "  " +
           list.lon;
        list.cog = item.cog ? parseFloat(item.cog).toFixed(1) + "°" : "--";
        list.heading = item.heading
          ? parseFloat(item.heading).toFixed(1) + "°"
          : "--";
        let state = item.aisNavStatusCn;
        switch (item.aisNavStatusCn) {
          case "发动机使用中":
            state = "在航";
            break;
          case "在航（主机推动）":
            state = "在航";
            break;
          case "受船舶吃水限制":
            state = "吃水限制";
            break;
          default:
            state = item.aisNavStatusCn;
            break;
        }
        list.state = state;
        // this.listData[0] = toRaw(list);
        // this.listData[0].reportName = "自动AIS";
        this.listData.forEach((listItem, index) => {
          for (let i in list) {
            if (i == listItem.value) {
              tabledata[index].autoAIS = list[i];
              tabledata[index].info = listItem.label;
            }
          }
        });
        this.tableData = tabledata;
        // console.log(this.tableData, "AIS");
      }
    },
    //度转度°分′秒″
    ToDegrees(val, type) {
      if (type == "lon") {
        const lonFilter = function (value) {
          if (!value) {
            return "";
          } else {
            if (value < -180) {
              return value + 360;
            } else if (value > 180) {
              return value - 360;
            } else {
              return value;
            }
          }
        };
        // 将经度改为33° 84′ W的形式
        const lon = lonFilter(parseFloat(val)).toString();
        if (!lon) {
          return;
        }
        let lonDir = "";
        if (Number(lon) < 0 || Number(lon) > 180) {
          lonDir = "W";
        } else {
          lonDir = "E";
        }
        const degree = parseInt(lon);
        const minute = Math.abs((parseFloat(lon) - degree) * 60);
        if (degree < 0) {
          return `${-degree}° ${minute.toFixed(2)}′ ${lonDir}`;
        } else {
          return `${degree}° ${minute.toFixed(2)}′ ${lonDir}`;
        }
      } else {
        // 将经度改为33° 84′ W的形式 只用在地图上鼠标移动显示经纬度
        // const lonStrFilter4MouseMove = function(value) {
        // const lon = lonFilter(parseFloat(value)).toString()
        // if (!lon) {
        // return
        // }
        // const degree = parseInt(lon)
        // const minute = Math.abs((parseFloat(lon) - degree) * 60)
        // if (degree < 0) {
        // return `${-degree}° ${minute.toFixed(2)}′ W`
        // } else {
        // return `${degree}° ${minute.toFixed(2)}′ E`
        // }
        // }

        const latFilter = function (value) {
          if (!value) {
            return "";
          } else {
            return value;
          }
        };

        // 将纬度改为33° 84′ S的形式
        const lat = latFilter(parseFloat(val)).toString();
        if (!lat) {
          return;
        }
        let latDir = "";
        if (Number(val) < 0) {
          latDir = "S";
        } else {
          latDir = "N";
        }
        const degree = parseInt(lat);
        const minute = Math.abs((parseFloat(lat) - degree) * 60);
        if (degree < 0) {
          return `${-degree}° ${minute.toFixed(2)}′ ${latDir}`;
        } else {
          return `${degree}° ${minute.toFixed(2)}′ ${latDir}`;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.yellow {
  span {
    color: #ff8b00 !important;
    animation: blink 1.5s linear infinite;
    cursor: pointer;
  }
}
.red {
  span {
    cursor: pointer;
    color: #ff4343 !important;
    animation: blink 1.5s linear infinite;
  }
}
.hide {
  display: none !important;
}
@keyframes blink {
  0% {
    opacity: 0.75;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.5;
  }
}
.basic-info {
  width: 95%;
  height: 95%;
  overflow: auto;
  display: inline-block !important;
}

:deep(.el-table) {
  background-color: transparent !important;
  --el-table-border-color: #0118327a !important;
  --el-table-row-hover-bg-color: #0118327a !important;
  cursor: pointer;
}
:deep(.el-table tr) {
  background: #0118327a !important;
  color: white;
}
:deep(.el-table .cell) {
  line-height: normal !important;
  padding: 0 5% !important;
}
:deep(.el-table th.el-table__cell) {
  background: #2bc6ff33 !important;
  color: #53c6ef;
}
:deep(.el-table tr:hover) {
  background: #0118327a !important;
  color: white;
}
:deep(.el-table .el-table__cell) {
  padding: 0.5% !important;
  border-bottom: 0px !important;
}
:deep(.el-table__inner-wrapper::before) {
  height: 0px !important;
}
@media screen and (max-width: 1500px) {
  ::v-deep table {
    border-collapse: separate;
    border-spacing: 0px 3px;
  }
  .el-table {
    font-size: 10px !important;
  }
}
@media screen and (min-width: 1501px) {
  ::v-deep table {
    border-collapse: separate;
    border-spacing: 0px 3px;
  }
  .el-table {
    font-size: 12px !important;
  }
}

@media screen and (min-width: 1921px) {
  ::v-deep table {
    border-collapse: separate;
    border-spacing: 0px 5px;
  }
  .el-table {
    font-size: 24px !important;
  }
  .el-table .el-table__cell {
    padding: 14px 0 !important;
  }
  .el-table .cell {
    line-height: 24px;
  }
}

@media screen and (min-width: 2561px) {
  ::v-deep table {
    border-collapse: separate;
    border-spacing: 0px 5px;
  }
  .el-table {
    font-size: 34px !important;
  }

  .el-table .el-table__cell {
    padding: 20px 0 !important;
  }

  .el-table .cell {
    line-height: 34px;
  }
}

@media screen and (min-width: 6700px) {
  ::v-deep table {
    border-collapse: separate;
    border-spacing: 0px 10px;
  }
  .el-table {
    font-size: 44px !important;
  }
  .el-table .el-table__cell {
    padding: 30px 0 !important;
  }
  .el-table .cell {
    line-height: 44px;
  }
}
</style>
